import { Injectable } from '@angular/core';
import { BFF_URL } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient) { }

  getUserProfile(): Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${BFF_URL}/v2/profile`, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });
  }

  sendVerificationEmail(email?: string): Promise<void> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return new Promise<void>((resolve, reject) => {
      this.http.post(`${BFF_URL}/v1/verify`, { email }, { headers })
        .pipe(take(1))
        .subscribe({
          next: () => resolve(),
          error: (error) => reject(error)
        });
    });
  }

  validateEmail(verificationCode: string): Promise<void> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    const body = { verificationCode };
    return new Promise<void>((resolve, reject) => {
      this.http.patch(`${BFF_URL}/v2/profile/verify-email-code`, body, { headers })
        .pipe(take(1))
        .subscribe({
          next: () => resolve(),
          error: (error) => reject(error)
        });
    });
  }

  updateUserProfile(updatedProfile): Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });

    return new Promise<any>((resolve, reject) => {
      this.http.patch<any>(`${BFF_URL}/v2/profile`, updatedProfile, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });
  }

  changePassword(data: { email: string; password: string }): Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${BFF_URL}/v1/auth/change-password`, data, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });
  }

  changeEmail(data: { newEmail: string }): Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${BFF_URL}/v1/auth/change-email`, data, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });
  }
}
